import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import * as Comments from "./getQueryKey";

/**
 * Hook for deleting a comment.
 * Automatically invalidates comment queries on success.
 */
export function useDeleteComment() {
  const { commentService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();

  const orgId = currentOrganization?.org_id ?? "";

  return useMutation<void, Error, string>({
    mutationFn: (commentId: string) => {
      if (!orgId) {
        throw new Error("CurrentOrganization is not set");
      }
      return commentService.deleteComment(commentId, { orgId });
    },
    onSuccess: () => {
      // Invalidate all comment queries to refetch without the deleted comment
      void queryClient.invalidateQueries({
        queryKey: Comments.getQueryKey(orgId),
      });
    },
  });
}
